module.exports = __webpack_public_path__ + "img/1active.541ea9fb.png";